/**
 * UserPreference fetched Actions
 */
export const USER_PREFERENCE_FETCHED = 'USER_PREFERENCE_FETCHED';
export function userPreferenceFetched(userPreference) {
  return {
    type: USER_PREFERENCE_FETCHED,
    userPreference: userPreference,
  };
}

export const USER_PREFERENCE_REQUEST_STARTED = 'USER_PREFERENCE_REQUEST_STARTED';
export function userPreferenceRequestStarted() {
  return {
    type: USER_PREFERENCE_REQUEST_STARTED,
    isFetchingUserPreferences: true,
  };
}
